/* eslint-disable react/jsx-no-bind,react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import PropTypes from 'prop-types';
import _ from 'lodash';
/* Components */
import ColumnPill from '../column-pill/column-pill';
/* Styles */
import './column-drag-and-drop.scss';

const sortColumnsByPriority = (col1, col2) => {
    return col1.priority - col2.priority;
};

const ColumnDragAndDrop = (props) => {
    const [allColumns, setAllColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [columnConfigObject, setColumnConfigObject] = useState(
        props.columnsConfig
    );

    const setInitialState = () => {
        const all = [];
        const selected = [];

        Object.entries(props.columnsConfig).forEach(([key, column]) => {
            if (column.shown) {
                selected.push({ ...column, name: key });
            } else {
                all.push({ ...column, name: key });
            }
        });
        selected.sort(sortColumnsByPriority);
        setAllColumns(all);
        setSelectedColumns(selected);
        setColumnConfigObject(_.cloneDeep(props.columnsConfig));
    };

    useEffect(() => {
        setInitialState();
    }, [props.columnsConfig]);

    const addToSelectedColumns = (event) => {
        const movedColumn = { ...allColumns[event.oldIndex] };
        setColumnConfigObject({
            ...columnConfigObject,
            [movedColumn.name]: { ...movedColumn, shown: true }
        });
    };

    const addToAllColumns = (event) => {
        const movedColumn = { ...selectedColumns[event.oldIndex] };
        setColumnConfigObject({
            ...columnConfigObject,
            [movedColumn.name]: { ...movedColumn, shown: false }
        });
    };

    const moveAllToSelected = () => {
        if (!(allColumns && allColumns.length)) {
            return;
        }
        const newConfigObj = {};
        allColumns.forEach(column => {
            newConfigObj[column.name] = { ...column, shown: true };
        });
        setColumnConfigObject({
            ...columnConfigObject,
            ...newConfigObj
        });
        setSelectedColumns([...selectedColumns, ...allColumns]);
        setAllColumns([]);
    };

    const moveAllFromSelected = () => {
        if (!(selectedColumns && selectedColumns.length)) {
            return;
        }
        const newConfigObj = {};
        selectedColumns.forEach(column => {
            newConfigObj[column.name] = { ...column, shown: false };
        });
        setColumnConfigObject({
            ...columnConfigObject,
            ...newConfigObj
        });
        setAllColumns([...selectedColumns, ...allColumns]);
        setSelectedColumns([]);
    };

    const onColumnClose = (columnName) => {
        const closedColumn = selectedColumns.find(
            (col) => col.label === columnName
        );
        const newSelectedColumns = selectedColumns.filter(
            (col) => col.label !== columnName
        );
        const newAllColumns = [...allColumns, closedColumn];
        setAllColumns(newAllColumns);
        setSelectedColumns(newSelectedColumns);
        setColumnConfigObject({
            ...columnConfigObject,
            [closedColumn.name]: { ...closedColumn, shown: false }
        });
    };

    const resetSelection = () => {
        setInitialState();
    };

    const getColumnsWithPriorities = () => {
        const columnWithPriorities = { ...columnConfigObject };
        [...selectedColumns, ...allColumns].forEach((column, index) => {
            columnWithPriorities[column.name].priority = index + 1;
        });
        return columnWithPriorities;
    };

    const applySelection = () => {
        const columnsWithPriorities = getColumnsWithPriorities();
        props.saveColumnConfig(columnsWithPriorities);
    };

    // TODO move to separated file as a util; Combine with component in Device Inventory widget
    const sortArrayOfLabelColumns = (a, b) => {
        // Use toUpperCase() to ignore character casing
        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();

        let comparison = 0;

        if (labelA > labelB) {
            comparison = 1;
        } else if (labelA < labelB) {
            comparison = -1;
        }
        return comparison;
    };

    allColumns.sort(sortArrayOfLabelColumns);

    return (
        <>
            <div className="glu-flex">
                <h3 className="glu-flex-grow">Selected columns</h3>
                <div className="glu-clickable-label" onClick={moveAllFromSelected}>Clear all</div>
            </div>
            <ReactSortable
                className="selected-columns"
                group="columnsGroup"
                onAdd={addToSelectedColumns}
                list={selectedColumns}
                setList={setSelectedColumns}
                animation={300}
                delay={0}
                style={{
                    minHeight: '10px'
                }}
            >
                {selectedColumns.map((item) => (
                    <ColumnPill
                        key={item.label}
                        label={item.label}
                        closable
                        onClose={onColumnClose}
                        columnClass="glu-pill--column-selected drag-column"
                    />
                ))}
            </ReactSortable>
            <div className="glu-flex">
                <h3 className="glu-flex-grow">All columns</h3>
                <div className="glu-clickable-label" onClick={moveAllToSelected}>Add all</div>
            </div>
            <ReactSortable
                className="all-columns"
                group="columnsGroup"
                onAdd={addToAllColumns}
                list={allColumns}
                setList={setAllColumns}
                animation={200}
                delay={0}
                style={{
                    minHeight: '10px'
                }}
            >
                {allColumns.map((item) => (
                    <ColumnPill
                        key={item.label}
                        label={item.label}
                        columnClass="glu-pill--column-default drag-column"
                    />
                ))}
            </ReactSortable>
            <div className="glu-flex-grow glu-flex-row">
                <div className="glu-flex-grow text-right">
                    <button
                        className="glu-btn glu-btn--secondary glu-reset"
                        onClick={resetSelection}
                    >
                        Reset
                    </button>
                </div>
                <div className="glu-flex-shrink">
                    <button
                        className="glu-btn glu-btn--primary"
                        onClick={applySelection}
                        disabled={!Object.keys(selectedColumns).length}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </>
    );
};

ColumnDragAndDrop.propTypes = {
    columnsConfig: PropTypes.objectOf(PropTypes.any),
    saveColumnConfig: PropTypes.func.isRequired
};

ColumnDragAndDrop.defaultProps = {
    columnsConfig: {}
};

export default ColumnDragAndDrop;
